import blockStyle from "./vulnBlock.module.css";

import { Vulnerability } from "../../../../../../../../sdkStructs";
import { Plus, Check, Sparkles } from "lucide-react";
import { useContext } from "react";
import { LoggerContext } from "../../../../../../../../contexts/LoggerContext";
import Tooltip from "../../../../../../../Common/Tooltips/Tooltip/Tooltip";

interface Props {
  data: Vulnerability;
  orderNumber: number;
  selectFunc: (data: Vulnerability, id: number) => void;

  openFunc: (data: Vulnerability) => void;
  addFunc: (data: Vulnerability) => void;
}

function VulnBlock({
  data,
  openFunc,
  selectFunc,
  addFunc,
  orderNumber,
}: Readonly<Props>) {
  const { flagMode } = useContext(LoggerContext);

  function getTitle() {
    if (data.Name === "") return "Unnamed Vuln";
    return data.Name;
  }

  function getTag() {
    if (!data.Tag) return "RandomTag";
    return data.Tag;
  }

  function tagClick(event: React.MouseEvent<HTMLButtonElement>) {
    event.stopPropagation();
    selectFunc(data, orderNumber);
  }

  function getGeneratedIcon() {
    if (data.Description === "")
      return (
        <Tooltip
          trigger={
            <button className={blockStyle.bookmarkButton} onClick={tagClick}>
              <Sparkles color="var(--light-blue-icon)" strokeWidth="1.7" />
            </button>
          }
          description="Generate"
          fixed
          showArrow
        />
      );
    return (
      <div className={blockStyle.generatedWrapper}>
        <Check stroke="var(--light-blue-icon)" strokeWidth="2" />
      </div>
    );
  }

  function getOptions() {
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div className={blockStyle.infoColumn}>
          <span className={blockStyle.blueVulnId}>#{orderNumber}</span>
          {getGeneratedIcon()}
        </div>
        <div className={blockStyle.infoColumn}>
          {data.Tag && <h5 className={blockStyle.vulnTag}>{getTag()}</h5>}
        </div>
      </div>
    );
  }

  const selectedWrapper = flagMode
    ? blockStyle.selectedWrapper
    : blockStyle.vulnWrapperHover;

  return (
    <div
      className={blockStyle.vulnWrapper + " " + selectedWrapper}
      onClick={() => openFunc(data)}
    >
      <div className={blockStyle.vulnContainer}>
        <h5 className={blockStyle.vulnTitle}>{getTitle()}</h5>
        {getOptions()}
      </div>

      {flagMode && (
        <button
          className={blockStyle.addRow}
          onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
            addFunc(data);
            event.stopPropagation();
          }}
        >
          <Plus stroke="white" strokeWidth="1.5" /> Add to this vuln
        </button>
      )}
    </div>
  );
}

export default VulnBlock;
